<script>
  import { tick } from 'svelte'
  import { onMount } from 'svelte'
  import { createPostRequest } from '../src/create_request'
  import { focus } from '../src/utils'
  import { cart } from '../src/data_storage.js'
  cart.useLocalStorage()

  import {_, locale} from 'svelte-i18n'
  import { Link } from "../rout"
  import Login from "./login.svelte"

  export let shop
  export let signedIn

  let email = ""
  let emailInput
  let activationSent = false
  let activated = false
  let error = null

  function signUp() {
    fetch(createPostRequest('/users.json',
                        'POST',
                        JSON.stringify({ user: { email: email }, slug: shop.slug})))
      .then(response => response.json())
      .then(data => {
        console.log('signUp:' + shop.slug)
        console.log(data)
        if (data.errors) {
          // alert(data.errors.email)
          error = data.errors.email
        } else if (data.id) {
          activationSent = true
          $cart[shop.id].activationSent = true
        } else {
          error = "Something went wrong, try again later."
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  onMount(async () => {
    console.log("signup onMount " + shop.slug)
    console.log("activationSent " + activationSent)
    console.log("activated " + activated)
  })
  $: activationSent = $cart[shop.id].activationSent || false
  $: activated = $cart[shop.id].activated || false
</script>

<style>
</style>

<div class="frame">
  {#if activated}
    Please sign in first!
    <Login on:signin/>
  {:else if activationSent}
    <div>Thanks for signing up. Please check for your activation email, then come back to complete your order.</div>
  {:else}
    <Login on:signin/>

    <div class="grow mt-8 flex flex-col justify-center items-center">
      <div class="text-lg font-bold">{$_('please_signup')}</div>
      <form id="signup-form" class="form" on:submit|preventDefault={signUp}>
        <div>
          <label for="signup-email">{$_('email')}</label>
          <input id="user[signup-email]" name="signup-email" type="email" required bind:value={email} bind:this={emailInput} use:focus/>
        </div>
        {#if error}
          <div class="mt-3 bg-red-100 flex flex-col items-center justify-center">
            {error}
          </div>
        {/if}
        <div>
          <button class="btn" type="submit">{$_('signup')}</button>
        </div>
      </form>
    </div>
  {/if}
</div>